<script lang="ts">

	import type { TeaserContent } from '../../../domain/teaser/TeaserContent.ts';
	import { toSignUpSheet } from '../../../domain/SheetData.ts';
	import { TeaserType } from '../../../domain/teaser/TeaserType.ts';
	import { trackClick, trackSeen, trackView } from '../../../services/tracking/TeaserTracking.ts';
	import { onMount } from 'svelte';
	import TrackingService from '../../../services/tracking/TrackingService.ts';
	import { onViewport } from '../../../services/tracking/IntersectionObserver';
	import { TeaserTouchPoint } from '../../../domain/teaser/TeaserUtils.ts';

	let { teaserContent }: {
		teaserContent: TeaserContent,
	} = $props();

	const teaserSize = 'MediaObject100';
	const teaserType = TeaserType.NON_UP_PLUS_BOOSTER_TEASER;
	let teaser: Element;
	let trackingService: TrackingService;


	onMount(() => {
		trackingService = new TrackingService();
		trackClick(trackingService, teaser, teaserContent, teaserType, teaserSize);
		trackView(trackingService, teaser, teaserContent, teaserType, teaserSize);
	});
</script>

<div class="oc-mt-100 oc-mb-150" bind:this={teaser}>NON_UP_PLUS_BOOSTER_TEASER component TBD</div>
